export const DASHBOARDS_LEARNING_PAGE_KEY =
  'analytics-hub-admin-dashboards-learning' as const;
